import { hasProp } from "../../helpers/Class";

class DistributionAddress {
    constructor(address = null) {
        this._id = !hasProp(address, "_id") ? undefined : address._id;
        this.name = !hasProp(address, "name") ? undefined : address.name;
        this.street = !hasProp(address, "street") ? undefined : address.street;
        this.streetBis = !hasProp(address, "streetBis") ? undefined : address.streetBis;
        this.zipCode = !hasProp(address, "zipCode") ? undefined : address.zipCode;
        this.city = !hasProp(address, "city") ? undefined : address.city;
        this.country = {
            name: !hasProp(address, "country.name") ? undefined : address.country.name,
            iso: !hasProp(address, "country.iso") ? undefined : address.country.iso,
        };
    }

    get addressLabel() {
        let addressLabel = this.street;
        if (this.streetBis) {
            addressLabel += ` ${this.streetBis}`;
        }
        addressLabel += "<br/>";
        if (this.zipCode) {
            addressLabel += ` ${this.zipCode}`;
        }
        addressLabel += ` ${this.city}`;
        addressLabel += ` ${this.country.name}`;
        return addressLabel;
    }
}

export default DistributionAddress;